export default "__VITE_ASSET__DDnNaJJp__"